import React, { PropTypes } from 'react';
import classnames from 'classnames';

const Suggestion = ({ text, onSelect, selected }) => {
    let classes = classnames({ selected });
    return <div className={classes} onClick={ onSelect }>{text}</div>;
};

Suggestion.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool,
    text: PropTypes.string.isRequired
};

export default Suggestion;


// WEBPACK FOOTER //
// ./src/components/autocomplete/suggestion.js